import React from "react"
import {Custom} from "../Custom"
import {HttpService} from "../../service/HttpService"
import {AuthService} from "../../service/AuthService";
import {HowTo} from "./HowTo";


export const HowToPage = () => {
  const customProject = HttpService?.customProject

  return (
      <>
        {customProject?.customFrontend &&
        customProject?.frontendComponents?.some(
            ( component ) => (component?.pathUrl === "/howto-custom" || (component?.pathUrl === "/public/howto-custom" && !AuthService.authorized))
        ) ? (
                <Custom
                    customFrontendUrl={customProject?.customFrontendUrl}
                    type={
                      customProject?.frontendComponents?.find(
                          ( comp ) => comp?.pathUrl === "/howto-custom" || (comp?.pathUrl === "/public/howto-custom" && !AuthService.authorized)
                      )?.component
                    }
                />
            ) :
            <HowTo />
        }
      </>
  )
}
